import { useEffect, useState } from 'react';
import PageLoader from '../../../../../component/PageLoader';
import SendEmail from '../../../../components/SendEmail';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchSalesReturnDetails, sendEmail } from '../../../../../services/sales_return';

const SalesReturnSendEmail = () => {
	const params = useParams();
	const { id } = params;
	const { userInfo } = useSelector((state) => state);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const [toEmails, setToEmails] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [salesReturnDetails, setSalesReturnDetails] = useState(null);
	const [emailFormData, setEmailFormData] = useState({
		from: '',
		to: [],
		subject: '',
		body: '',
		isAttachment: true,
	});

	async function handleSend(formData) {
		try {
			await sendEmail(id, formData);
			toast.success('Email Sent Successfully.');
			navigate(`/user/${suburl}/sales-return`);
		} catch (error) {
			throw error;
		}
	}

	function handleClose() {
		navigate(`/user/${suburl}/sales-return`);
	}

	async function handleFetchPRDetails() {
		try {
			setIsLoading(true);
			const { sales_return } = await fetchSalesReturnDetails({ ids: [Number(id)] });
			setSalesReturnDetails(sales_return);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchPRDetails();
		}
	}, [id]);

	useEffect(() => {
		if (salesReturnDetails && userInfo) {
			const { return_number, customer } = salesReturnDetails;

			var customerEmailList = [];
			var customerToSendEmailList = [];
			if (customer?.email) {
				customerEmailList.push(customer.email);
				customerToSendEmailList.push(customer.email);
			}
			setEmailFormData((prev) => ({
				...prev,
				to: customerToSendEmailList,
				from: `${userInfo?.userInfo?.data?.userData?.first_name} ${userInfo?.userInfo?.data?.userData?.last_name}`,
				subject: `Sales Return from ${userInfo?.userInfo?.data?.userData?.first_name + ' ' + userInfo?.userInfo?.data?.userData?.last_name} (Sales Return #: ${return_number})`,
			}));
			setToEmails(customerEmailList);
		}
	}, [salesReturnDetails, userInfo]);

	if (isLoading) {
		return <PageLoader />;
	}

	return (
		<SendEmail
			pdfName="Sales Return"
			pdfId={`${salesReturnDetails?.return_number}`}
			toEmails={toEmails}
			formData={emailFormData}
			handleSend={handleSend}
			handleClose={handleClose}
			isDropdownListShow={false}
		/>
	);
};

export default SalesReturnSendEmail;
